import Vue from 'vue'
import VueScrollPicker from 'vue-scroll-picker'
import 'vue-scroll-picker/dist/style.css'

Vue.use(VueScrollPicker)